export function handleError(key: string, error: any): DevvSdkError {
    console.error(key, error)
    return new DevvSdkError({ message: key, data: error.response?.data })
}

interface DevvSdkErrorData {
    code: string
    status?: string
    message?: string
    message_history?: string
    errors?: any
    error_history?: {
        message: string
        status: number
        code: string
        data: any
        visible: boolean
    }[]
}

class DevvSdkError extends Error {
    date: Date
    data: DevvSdkErrorData

    constructor({ message = 'DEVV_SDK_ERROR', data }: { message: string; data: DevvSdkErrorData }) {
        super(message)

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, DevvSdkError)
        }

        this.data = data
        this.date = new Date()
    }
}

export default DevvSdkError
